import { BackendPaginationService } from 'app/core/backend-pagination.service';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { TableParameters } from 'app/component-library/table/table-parameters';
import { BackendService } from '../../../core/backend.service';
import { PlannedMaintenanceLibraryItem } from '../../../viewmodels/planned-maintenance/planned-maintenance-library-item';
import { PlannedMaintenanceLibraryService } from '../../../planned-maintenance-library/planned-maintenance-library.service';
import { MaintenanceStrategyPlannedMaintenance } from '../../../viewmodels/maintenance-strategies/maintenance-strategy-planned-maintenance';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceStrategyPlannedMaintenanceService {
  deletedMaintenance = new Subject<MaintenanceStrategyPlannedMaintenance[]>();
  acceptedAddedMaintenance = new Subject<MaintenanceStrategyPlannedMaintenance[]>();
  availablePlannedMaintenance = new Subject<MaintenanceStrategyPlannedMaintenance[]>();
  loadPlannedMaintenanceRequested = new Subject();
  plannedMaintenanceLoaded = new Subject<PlannedMaintenanceLibraryItem>();

  constructor(
    private backendService: BackendService,
    private plannedMaintenanceLibraryService: PlannedMaintenanceLibraryService,
    private backendPaginationService: BackendPaginationService,
  ) {}

  public deleteMaintenance(maintenance: MaintenanceStrategyPlannedMaintenance[]): void {
    this.deletedMaintenance.next(maintenance);
  }

  public acceptAddedMaintenance(maintenances: MaintenanceStrategyPlannedMaintenance[]): void {
    this.acceptedAddedMaintenance.next(maintenances);
  }

  public loadAvailablePlannedMaintenance(selectedPlannedMaintenanceItems: MaintenanceStrategyPlannedMaintenance[]): void {
    this.backendService.getAll(PlannedMaintenanceLibraryItem).subscribe(plannedMaintenance => {
      const unselectedMaintenanceItems = plannedMaintenance.filter(
        maintenance => !selectedPlannedMaintenanceItems.find(selectedMaintenance => selectedMaintenance.plannedMaintenanceLibraryItemId === maintenance.id)
      );
      const availablePlannedMaintenance = this.createAvailablePlannedMaintenanceItems(unselectedMaintenanceItems);
      this.availablePlannedMaintenance.next(availablePlannedMaintenance);
    });
  }

  public loadPlannedMaintenance(plannedMaintenanceLibraryItemId: string): void {
    if(!plannedMaintenanceLibraryItemId) {
      this.plannedMaintenanceLoaded.next(null);
      return;
    }

    this.loadPlannedMaintenanceRequested.next();

    this.plannedMaintenanceLibraryService.getPlannedMaintenance(plannedMaintenanceLibraryItemId).subscribe(plannedMaintenance => {
      this.plannedMaintenanceLoaded.next(plannedMaintenance);
    });
  }

  public savePlannedMaintenance(plannedMaintenanceLibraryItem: PlannedMaintenanceLibraryItem): void {
    this.plannedMaintenanceLibraryService.save(plannedMaintenanceLibraryItem).subscribe(maintenanceItem => {
      if (maintenanceItem) {
        this.acceptAddedMaintenance([this.createAvailablePlannedMaintenanceItem(maintenanceItem)]);
        this.plannedMaintenanceLoaded.next(maintenanceItem);
      }
    });
  }

  public createAvailablePlannedMaintenanceItems(plannedMaintenanceItems: PlannedMaintenanceLibraryItem[]): MaintenanceStrategyPlannedMaintenance[] {
    return plannedMaintenanceItems.map(maintenance => this.createAvailablePlannedMaintenanceItem(maintenance));
  }

  private createAvailablePlannedMaintenanceItem(plannedMaintenance: PlannedMaintenanceLibraryItem): MaintenanceStrategyPlannedMaintenance {
    const availablePlannedMaintenance = new MaintenanceStrategyPlannedMaintenance();
    availablePlannedMaintenance.loadFromLibraryItem(plannedMaintenance);

    return availablePlannedMaintenance;
  }


  public paginationLoadCurrentPageAvailableItems(tableParameters: TableParameters): Observable<PlannedMaintenanceLibraryItem[]> {
    return this.backendPaginationService
      .paginateWithParameters<PlannedMaintenanceLibraryItem>(PlannedMaintenanceLibraryItem, tableParameters, tableParameters.skip, tableParameters.take, false);
  }

  public loadAvailableItemsCount(tableParameters: TableParameters): Observable<number> {
    return this.backendPaginationService
      .getCountWithParameters<PlannedMaintenanceLibraryItem>(PlannedMaintenanceLibraryItem, tableParameters, false);
  }
}
